import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import BlogFive from '../components/blog/BlogFive';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const BlogGridPage = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                heading="Blog Grid"
                currentPage="Blog Grid" 
            />
            <BlogFive />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default BlogGridPage;